<template>
    <div>
        <b-modal
            :visible="value"
            id="import-history-modal"
            size="lg"
            no-close-on-backdrop
            no-close-on-esc
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
        >
            <template #modal-title>
                Import History
                <span v-if="publication && publication.title">
                    - {{ publication.title }} (ID: {{ publication.id }})
                </span>
            </template>

            <div v-if="loading" class="text-center my-3">
                <b-spinner label="Loading..."></b-spinner>
            </div>

            <b-alert v-else-if="!logs.length" show variant="light" class="mb-0">
                No import history found for this publication.
            </b-alert>

            <b-table
                v-else
                striped
                responsive
                outlined
                :items="formatted_logs"
                :fields="fields"
            />

            <template #modal-footer>
                <b-button
                    variant="light"
                    @click="hide"
                >
                    Close
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'ImportHistoryModal',
    data: () => ({
        loading: false,
        logs: [],
        fields: [
            {
                key: 'created_at',
                label: 'Date'
            },
            {
                key: 'publish_type',
                label: 'Type'
            },
            {
                key: 'unit_id',
                label: 'Week ID'
            },
            {
                key: 'article_id',
                label: 'Article ID'
            },
            {
                key: 'details',
                label: 'Details'
            },
            {
                key: 'created_by',
                label: 'Imported By'
            }
        ]
    }),
    props: [
        'value',
        'publication'
    ],
    computed: {
        formatted_logs() {
            return this.logs.map(log => {
                return {
                    created_at: moment(log.created_at).format('MMM D, YYYY h:mm A'),
                    publish_type: this.formatPublishType(log.publish_type),
                    unit_id: this.formatContextValue(log, 'unit_id'),
                    article_id: this.formatContextValue(log, 'article_id'),
                    details: this.formatDetails(log),
                    created_by: this.formatUser(log.user)
                }
            })
        }
    },
    watch: {
        value: {
            handler(value) {
                if (value == true) {
                    this.getImportHistory()
                }
            }
        }
    },
    methods: {
        async getImportHistory() {
            if (!this.publication || !this.publication.id) {
                this.logs = []
                return
            }

            this.loading = true

            try {
                let response = await this.axios.get('/api/publications/import_history/' + this.publication.id)

                this.logs = response.data
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to get import history: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            } finally {
                this.loading = false
            }
        },
        formatPublishType(publish_type) {
            if (!publish_type) {
                return ''
            }

            return _.startCase(publish_type)
        },
        formatDetails(log) {
            if (!log.context) {
                return ''
            }

            return ''
        },
        formatContextValue(log, key) {
            if (!log.context || !log.context[key]) {
                return ''
            }

            return log.context[key]
        },
        formatUser(user) {
            if (!user) {
                return ''
            }

            let name = _.trim((user.first_name || '') + ' ' + (user.last_name || ''))

            return name || user.email
        },
        cancel(event) {
            event.preventDefault()

            this.hide()
        },
        hide() {
            this.$emit('hide')
        },
        hidden() {
            this.$emit('hide')
        }
    }
}
</script>
